/**
 * Offloads TSV parse/unparse so large copy/paste does not block the UI thread.
 * Kept as a module worker so Vite/Nuxt can bundle papaparse into it.
 */
import Papa from 'papaparse'

self.onmessage = (event) => {
  const { id, op, payload, config = {} } = event.data || {}
  try {
    if (op === 'parse') {
      const { data } = Papa.parse(payload, config)
      self.postMessage({ id, result: data })
      return
    }
    if (op === 'unparse') {
      self.postMessage({ id, result: Papa.unparse(payload, config) })
      return
    }
    self.postMessage({ id, error: `Unknown clipboard TSV op: ${op}` })
  } catch (error) {
    self.postMessage({
      id,
      error: error?.message || String(error),
    })
  }
}
